import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";
import { PlanHeaderProps } from "../../../../@types/components/enrollmentProps.types";

import CodeIcon from "@material-ui/icons/Code";

import "./planHeader.css";

const PlanHeader = ({ planName, planCode, planLogo }: PlanHeaderProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="plan-header">
			<div className="header-logo">
				<div>
					<div className="header">{planName}</div>
					<div
						className="sub-header"
						style={{ color: theme.primary_color, borderLeftColor: theme.primary_color }}
					>
						<div className="code-text" style={{ color: "red" }}>
							Plan Code: {planCode}
						</div>
					</div>
				</div>
				{planLogo ? (
					<div className="logo">
						<img
							src={planLogo as unknown as string}
							className="helping-your-own-logo"
							id="helping-your-own-logo"
							alt="Helping your Own Logo"
						/>
					</div>
				) : null}
			</div>
			{/* <div
				className="divider-grad-mask"
				style={{
					background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
				}}
			/> */}
		</div>
	);
};

export default PlanHeader;
